import { FormControl, MenuItem, Select } from "@mui/material";

import { applyTextFormat } from "../helpers";

const FormatDropdown = ({ editor, currentFormat, setCurrentFormat }) => {
	const handleFormatChange = (event) => {
		const format = event.target.value;
		applyTextFormat(editor, format, setCurrentFormat);
	};

	const getScriptStyle = (value) => {
		const lineOffset = value === "superscript" ? { top: "-4px" } : { bottom: "-4px" };
		return {
			fontSize: "14px",
			padding: "8px 14px",
			"& > span": {
				position: "relative",
				fontSize: "75%",
				lineHeight: 0,
				...lineOffset
			}
		};
	};

	const getMenuItemStyle = (value) => {
		switch (value) {
			case "normal":
				return { fontSize: "16px", fontWeight: 400, padding: "4px 14px" };
			case "h1":
				return { fontSize: "28px", fontWeight: 600, padding: "4px 14px" };
			case "h2":
				return { fontSize: "24px", fontWeight: 600, padding: "4px 14px" };
			case "h3":
				return { fontSize: "20px", fontWeight: 600, padding: "4px 14px" };
			case "superscript":
				return {...getScriptStyle("superscript")};
			case "subscript":
				return {...getScriptStyle("subscript")};
			default:
				return { fontSize: "14px", padding: "8px 14px" };

		}
	};

	return (
		<FormControl variant="outlined" size="small" sx={{ minWidth: 140, mr: 1 }}>
			<Select
				value={currentFormat}
				onChange={handleFormatChange}
				sx={{
					height: "30px",
					fontSize: "14px",
					"& .MuiSelect-select": {
						padding: "5px 14px",
						paddingRight: "32px", 
					}
				}}
				MenuProps={{
					anchorOrigin: {
						vertical: "bottom",
						horizontal: "left",
					},
					transformOrigin: {
						vertical: "top",
						horizontal: "left",
					},
					PaperProps: {
						sx: {
							maxHeight: 300,
						}
					}
				}}
			>
				<MenuItem value="normal" sx={getMenuItemStyle("normal")}>Normal</MenuItem>
				<MenuItem value="h1" sx={getMenuItemStyle("h1")}>Heading 1</MenuItem>
				<MenuItem value="h2" sx={getMenuItemStyle("h2")}>Heading 2</MenuItem>
				<MenuItem value="h3" sx={getMenuItemStyle("h3")}>Heading 3</MenuItem>
				<MenuItem value="superscript" sx={getMenuItemStyle("superscript")}>Text<span>superscript</span></MenuItem>
				<MenuItem value="subscript" sx={getMenuItemStyle("subscript")}>Text<span>subscript</span></MenuItem>
			</Select>
		</FormControl>
	);
};

export default FormatDropdown;